<template>
  <v-app-bar class="navbar-top" dense dark>
    <v-toolbar-title>{{ pageTitle }}</v-toolbar-title>

    <v-spacer></v-spacer>

    <v-menu left bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on">
          <v-icon size="15">fas fa-ellipsis-v</v-icon>
        </v-btn>
      </template>

      <v-list>
        <v-list-item @click="onLogout">
          <v-list-item-title>Deslogar</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-app-bar>
</template>

<script>
import * as _ from 'lodash'
export default {
  computed: {
    pageTitle() {
      return _.get(this.$route, 'meta.title', '')
    },
  },
  methods: {
    onLogout() {
      localStorage.removeItem('authorization')
      setTimeout(() => this.$router.push('/login'), 500)
    },
  },
}
</script>

<style lang="scss">
.navbar-top {
  padding: 0 20px !important;
}
</style>
